export const appPricingTablePlans = [
  'free',
  'basic',
  'pro',
  'premium',
  'entertainment',
] as const;

export type IAppPricingTablePlan = (typeof appPricingTablePlans)[number];
